module.exports = __webpack_public_path__ + "img/cover_2.4c1359ef.png";